export enum GasMeterTypes {
    standard=0,
    payg=1,
    smart=2
}